const mutations = {
  SET_SEGMENTS(state, segments) {
    state.segments = segments
  },
  SET_SMS_TEMPLATES(state, smsTemplates) {
    state.smsTemplates = smsTemplates
  },
  SET_EMAIL_TEMPLATES(state, emailTemplates) {
    state.emailTemplates = emailTemplates
  },
  SET_ANNOUNCEMENTS(state, announcements) {
    state.announcements = announcements
  },
}

export default mutations
